import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { ReactNode } from "react";

import { UserLanguageContext } from "./UserLanguageContext";
import { instance } from "../../axios/instance";

import { SelectLanguageResponse } from "@/types/response/SelectLanguageResponse";

type UserLanguageProviderProps = {
  children: ReactNode;
  id: string;
};

export const UserLanguageProvider = ({
  children,
  id,
}: UserLanguageProviderProps) => {
  const userLanguage: UseMutationResult<
    AxiosResponse<SelectLanguageResponse>,
    AxiosError<AxiosError>,
    string
  > = useMutation({
    mutationFn: (language) => instance.put(`/api/v2/Users/${id}/language/${language}`),
  });

  const value = {
    userLanguage: userLanguage.mutate,
  };

  return (
    <UserLanguageContext.Provider value={value}>
      {children}
    </UserLanguageContext.Provider>
  );
};
